import { Component } from '@angular/core';
import { QPointSafeHtmlPipe } from '../../../../projects/qpoint-layout/src/lib/pipes/qpoint-safe-html.pipe';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { QPointButtonComponent } from '../../../../projects/qpoint-button/src/lib/button/button.component';
import { QPointToolbarComponent, QPointContentContainerComponent, QPointHiddenDirective } from '@qpoint/layout';
import { QPointDateFormatPipe } from "../../../../projects/qpoint-i18n/src/lib/pipes/q-date-format.pipe";
import { QPointDateFormat } from '../../../../projects/qpoint-i18n/src/lib/services/DateFormat';
import { utcToZonedTime } from 'date-fns-tz';


@Component({
    selector: 'app-directives',
    templateUrl: './directives.component.html',
    imports: [
        QPointToolbarComponent,
        QPointContentContainerComponent,
        QPointButtonComponent,
        NgbTooltip,
        QPointSafeHtmlPipe,
        QPointHiddenDirective,
        QPointDateFormatPipe
    ]
})
export class ControlGalleryDirectivesComponent {
  public dateFormat = QPointDateFormat;

  public hidden = false;
  public htmlContent = '<h3>This is dynamic html content</h3>';
  truncatedTextMaxWidth = 10;

  currentDatetime = new Date();
  utcString = this.currentDatetime.toISOString();
  targetTimeZone = 'America/Costa_Rica'; // Target time zone
  // Convert UTC timestamp to the specified time zone
  currentDatetimeInTargetZone = utcToZonedTime(this.utcString, this.targetTimeZone);

  toggle() {
    this.hidden = !this.hidden;
  }

  toggleTruncatedTextMaxWidth() {
    this.truncatedTextMaxWidth = this.truncatedTextMaxWidth === 10 ? 100 : 10;
  }
}
